import React, { lazy } from 'react';
import { withLoadingAndErrorStates } from '@guildeducationinc/mfe-utils';
import { ShimmerLoader } from '@guildeducationinc/recess';
import { logDataDogError } from '@src/utilities/datadog';

const ProgramCardRemote = lazy(
	() => import(/* webpackChunkName: "remote/ProgramCard" */ 'CatalogTools/ProgramCard')
);

export const ProgramCard = withLoadingAndErrorStates({
	component: ProgramCardRemote,
	errorAs: (error, componentStack) => {
		logDataDogError(error, 'ProgramCardRemoteError', { componentStack });
		return <></>;
	},
	loadingAs: <ShimmerLoader height={250} label='Program Card' loaded={false} marginBottom={16} />,
});
